export default __webpack_public_path__ + "static/media/slider02.ff5a3edb.png";